module.exports = __webpack_public_path__ + "static/media/vkb_logo.91abb20e.jpg";